module.exports = __webpack_public_path__ + "img/brcdetails.d6440f97.png";